import { FC } from 'react';
import SkeletonAtom from 'components/atoms/SkeletonAtom';
import './styles.scss';

const AlertNotificationLoadingDrawer: FC = () => {
  return (
    <div>
      <div className={'AlertNotificationLoadingDrawer__info-loading'}>
        <div className={'AlertNotificationLoadingDrawer__info-loading-icon'}>
          <SkeletonAtom.Input active />
        </div>
        <div className={'AlertNotificationLoadingDrawer__info-loading-body'}>
          <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-body-skeleton'} active />
          <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-body-skeleton'} active />
          <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-body-skeleton'} active />
        </div>
      </div>
      <div className={'AlertNotificationLoadingDrawer__info-loading-switch'}>
        <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-switch-text-skeleton'} active />
        <div className={'AlertNotificationLoadingDrawer__info-loading-switch-button-skeleton'}>
          <SkeletonAtom.Input active />
        </div>
      </div>
      <div className={'AlertNotificationLoadingDrawer__info-loading-select'}>
        <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-select-text-skeleton'} active />
        <SkeletonAtom.Input className={'AlertNotificationLoadingDrawer__info-loading-select-button-skeleton'} active />
      </div>
    </div>
  );
}

export default AlertNotificationLoadingDrawer;